import { render, staticRenderFns } from "./AddCourseSyllabus.vue?vue&type=template&id=45b3b199&scoped=true&"
import script from "./AddCourseSyllabus.vue?vue&type=script&lang=js&"
export * from "./AddCourseSyllabus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b3b199",
  null
  
)

export default component.exports